import {Base,Axios} from "@/api/Base"

export class PaymentDownCommissionPaymentByIdSal extends Base {

    path = "payment/downCommissionPaymentByIdSal"
    download(param = {}) {
        return Axios.get(this.path, { params: param,responseType: "blob" })
    }
}